import React, { useEffect, useState } from 'react';
import { Eye, ChevronUp, ChevronDown } from 'react-feather';
import Table from '../../../components/Table/Table';
import IconCounter from '../../../components/IconCounter';
import ProfileImage from '../../../components/ProfileImage';
import { useRemote, useStorage } from '../../../Utils/Utils';
import { format, sub } from 'date-fns';
import AnalyticsHeader from './AnalyticsHeader'
import Divider from '../../../components/Divider';
import { useHistory } from 'react-router-dom';

const TopAnalystsTable = ({ dateRanges }) => {
	const remote = useRemote();
	const storage = useStorage();
	const history = useHistory();
	const [allData, setAllData] = useState([])
	const [authorData, setAuthorData] = useState([])
	const [analysts, setAnalysts] = useState([])
	const [authorsDateRange, setAuthorsDateRange] = useState(dateRanges[0]);
	const [sortingColumn, setSortingColumn] = useState({ column: "PortalViews", ascending: false })

	const end = format(new Date(), 'yyyy-MM-dd')

	useEffect(() => {
		storage.getOrFetch(`/portal/analysts`).then(fetchedAnalysts => {
			setAnalysts(fetchedAnalysts)
			// const dummyAnalysts = [
			// 	{
			// 		email: "Felipe.Japito@craigsip.com",
			// 		isAuthor: true,
			// 		name: 'Felipe Japito',
			// 	},
			// 	{
			// 		email: "Jeronimo.Duarte@craigsip.com",
			// 		isAuthor: true,
			// 		name: 'Jeronimo Duarte',
			// 	},
			// 	{
			// 		email: "Momo.Lulu@craigsip.com",
			// 		isAuthor: true,
			// 		name: 'Momo Lulu',
			// 	},
			// 	{
			// 		email: "Chocho.San@craigsip.com",
			// 		isAuthor: true,
			// 		name: 'Chocho San',
			// 	},
			// 	{
			// 		email: "Suki.Su@craigsip.com",
			// 		isAuthor: true,
			// 		name: 'Suki Su',
			// 	},
			// 	{
			// 		email: "Camilita.Yang@craigsip.com",
			// 		isAuthor: true,
			// 		name: 'Camilita Yang',
			// 	},
			// 	{
			// 		email: "Lavanda.Janda@craigsip.com",
			// 		isAuthor: true,
			// 		name: 'Lavanda Janda',
			// 	},
			// 	{
			// 		email: "Olga.Ortega@craigsip.com",
			// 		isAuthor: true,
			// 		name: 'Olga Ortega',
			// 	},
			// 	{
			// 		email: "Sulma.Caban@craigsip.com",
			// 		isAuthor: true,
			// 		name: 'Sulma Caban',
			// 	},
			// 	{
			// 		email: "Chester.Rey@craigsip.com",
			// 		isAuthor: true,
			// 		name: 'Chester Rey',
			// 	},
			// ]
			// setAnalysts(dummyAnalysts)
		});
	}, [])

	useEffect(() => {
		let time = { months: 6 }

		if (authorsDateRange) {
			time = authorsDateRange
		}
		let date = typeof authorsDateRange === "string" ? authorsDateRange : format(sub(new Date(), time), "yyyy-MM-dd")
		remote.get(`/analytics/aggregates/documents?from=${date}&to=${end}`).then((stats) => {
			const authorAggregate = {};

			stats.forEach(r => {
				const authorStats = authorAggregate[r.publishedBy] || { author: r.publishedBy, count: 0, minutes: 0, uniqueViews: 0 };
				authorStats.uniqueViews += r.uniqueViews
				authorAggregate[r.publishedBy] = authorStats;

			})
			const authorAsArray = Object.keys(authorAggregate).map(key => authorAggregate[key])
			setAllData(authorAsArray)
			// const dummyData = [
			// 	{ author: 'Felipe Japito', uniqueViews: 10 },
			// 	{ author: 'Jeronimo Duarte', uniqueViews: 7 },
			// 	{ author: 'Momo Lulu', uniqueViews: 11 },
			// 	{ author: 'Chocho San', uniqueViews: 3 },
			// 	{ author: 'Suki Su', uniqueViews: 4 },
			// 	{ author: 'Camilita Yang', uniqueViews: 6 },
			// 	{ author: 'Lavanda Janda', uniqueViews: 1 },
			// 	{ author: 'Olga Ortega', uniqueViews: 9 },
			// 	{ author: 'Sulma Caban', uniqueViews: 5 },
			// 	{ author: 'Chester Rey', uniqueViews: 8 },
			// ]
			// setAllData(dummyData)
		});
	}, [authorsDateRange]);

	useEffect(() => {
		sortTable(sortingColumn.column, 'descending')
	}, [allData])


	function sortTable(column, string) {
		let tableData = allData

		const ascending = sortingColumn.column === column ? string && string === 'descending' ? false : !sortingColumn.ascending : true
		switch (column) {
			case "Minutes":
				tableData.sort((a, b) => ascending ? a.minutes - b.minutes : b.minutes - a.minutes)
				break;
			case "PortalViews":
				tableData.sort((a, b) => ascending ? a.uniqueViews - b.uniqueViews : b.uniqueViews - a.uniqueViews)
				break;
			default:
				break;
		}
		const topFive = tableData.slice(0, 5)
		setSortingColumn({ column: column, ascending: ascending })
		setAuthorData(topFive)
	}

	return <>
		<div className='db-table-header'>
			<AnalyticsHeader dateRanges={dateRanges} timeFrame={authorsDateRange} setTimeFrame={setAuthorsDateRange}>Authors - Most Viewed</AnalyticsHeader>
			<Divider vertical style={{ marginBottom: '1.5rem', height: 16 }} />
			<div className='db-table-header-sorting-icons'>
				<div className='sorting-header' onClick={() => sortTable("PortalViews")}>
					<Eye className="colour-text-primary" size={16} />
					{sortingColumn && sortingColumn.column === "PortalViews" && sortingColumn.ascending === true ?
						<ChevronUp className="colour-text-primary" size={12} /> :
						<ChevronDown className={sortingColumn && sortingColumn.column === "PortalViews" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
					}
				</div>
			</div>
		</div>
		<AuthorTable data={authorData} changeRoute={(url) => history.push(url)} authors={analysts} />
	</>

}

const getInitials = (name) => {
	const arr = name && name.split(" ") || []
	let initials = arr.map(word => word.charAt(0))
	return initials.join("")
}

const AuthorTable = ({ data, authors, changeRoute }) => {
	const colWidths = ["52px", "auto", "150px"];

	const dataMap = () => data && data.map((research, idx) => {
		const relevantAnalyst = authors && authors.find(a => a.name === research.author);

		return (
			<tr key={idx} className="cursor-pointer" onClick={() => changeRoute(`/analytics/authors/author/${relevantAnalyst.email}`)}>
				<td>
					<ProfileImage user={relevantAnalyst} initials={getInitials(research.author)} src={relevantAnalyst && relevantAnalyst.photo ? "data:image/png;base64, " + relevantAnalyst.photo : null} size={24} />
				</td>
				<td className="truncate">{research.author}</td>
				<td className="table-action-icons transition-fade-in-slow">
					<div className='top-research-icons  top-authors-viewed-icons'>
						<IconCounter icon={<Eye />} tooltip="Views" dataAvailable count={research.uniqueViews} />
					</div>
				</td>
			</tr>
		);
	});

	return <Table suggestionMessage rowSize="s" colWidths={colWidths} dataMap={dataMap()} />

}

export default TopAnalystsTable;